import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Asset, Box, Button, Card, Radio, Typography, useThemeValue } from '@altermaind/web/ui';
import { Avatars } from '../../state';
import { AvatarAltermaind, AvatarStatic3D } from '../Avatars';
import { WrapperConversation } from '../WrapperConversation';

type Props = {
  currentAvatar: Avatars;
  setCurrentAvatar: (avatar: Avatars) => void;
  setCurrentStep: (step: number) => void;
};

export const ChooseAvatar: FC<Props> = ({ currentAvatar, setCurrentAvatar, setCurrentStep }) => {
  const t = useTranslations('conversations.chooseAvatar');
  const spacexS = useThemeValue('space', 'xs');

  const goToNextStep = () => {
    setCurrentStep(1);
  };

  return (
    <WrapperConversation>
      <Box
        pt='l'
        px='huge'
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100%'
      >
        <Box flex='1'>
          <Typography variant='special'>{t('title')}</Typography>
          <Typography variant='p3/light' mt='xxs'>
            {t('subtitle')}
          </Typography>
          <Box display='flex'>
            <Box
              border='1px solid'
              borderRadius='8px'
              p='s'
              mt='m'
              mr='s'
              borderColor={
                currentAvatar === Avatars.ALTERMAIND ? 'primary' : 'grey/light/background'
              }
              textAlign='center'
              minWidth='200px'
              alignItems='center'
              onClick={() => setCurrentAvatar(Avatars.ALTERMAIND)}
              style={{ cursor: 'pointer' }}
            >
              <Asset domain='images' name='avatarAltermaind' height='120' />
              <Box width='fit-content' style={{ margin: '0 auto', marginTop: spacexS }}>
                <Radio checked={currentAvatar === Avatars.ALTERMAIND} />
              </Box>
            </Box>
            <Box
              border='1px solid'
              borderRadius='8px'
              p='s'
              mt='m'
              mr='s'
              borderColor={currentAvatar === Avatars.AVATAR3D ? 'primary' : 'grey/light/background'}
              textAlign='center'
              minWidth='200px'
              alignItems='center'
              onClick={() => setCurrentAvatar(Avatars.AVATAR3D)}
              style={{ cursor: 'pointer' }}
            >
              <Asset domain='images' name='avatarFederica' height='120' />
              <Box width='fit-content' style={{ margin: '0 auto', marginTop: spacexS }}>
                <Radio checked={currentAvatar === Avatars.AVATAR3D} />
              </Box>
            </Box>
          </Box>
          <Button onClick={goToNextStep} mt='s' variant='positive'>
            {t('cta.continue')}
          </Button>
        </Box>
        <Box flex='2'>
          <Card
            height='400px'
            p='none'
            display='flex'
            alignItems='center'
            justifyContent='center'
            position='relative'
            ml='m'
            textAlign='center'
          >
            {currentAvatar === Avatars.ALTERMAIND && <AvatarAltermaind />}
            {currentAvatar === Avatars.AVATAR3D && <AvatarStatic3D />}
          </Card>
        </Box>
      </Box>
    </WrapperConversation>
  );
};
